import { render, staticRenderFns } from "./ManagementHome.vue?vue&type=template&id=2bc748c2&scoped=true&"
import script from "./ManagementHome.vue?vue&type=script&lang=js&"
export * from "./ManagementHome.vue?vue&type=script&lang=js&"
import style0 from "./ManagementHome.vue?vue&type=style&index=0&id=2bc748c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc748c2",
  null
  
)

export default component.exports